import styles from "./Statistics.module.scss";
import { useStatisticsPage } from "./hooks/useStatisticsPage";
import {
  ALL_HALLS_OPTION_ID,
  ALL_USERS_OPTION_ID,
  IStatisticsFormModel,
} from "./models/statisticsFormModel";
import { nameof } from "ts-simple-nameof";
import { DefaultButton } from "../../common/components/button/defaultButton/DefaultButton";
import { FormProvider } from "react-hook-form";
import { SingleSectionPageLayout } from "../../common/components/common/SingleSectionPageLayout";
import { DefaultFormSelectField } from "../../common/components/forms/inputs/dropdown/DefaultFormSelectField";
import { RangeCalendar } from "../../common/components/forms/inputs/RangeCalendar/RangeCalendar";
import { DefaultFormMultiSelectField } from "../../common/components/forms/inputs/dropdown/DefaultFormMultiSelectField";
import { StatisticsType } from "../../common/enums";
import { RenderWhen } from "../../common/infrastructure/components/RenderWhen";
import { NapAuditPanel } from "./napAudit/NapAuditPanel";

const RESOURCES_MIN_DATE = new Date(2026, 2, 6); // 06.03.2026

export const Statistics = () => {
  const {
    statisticTypeOptions,
    form,
    availableEmployees,
    availableHalls,
    tenantUsesMoreThanOneHall,
    canSeeAllEmployees,
    selectedType,
    onSave,
  } = useStatisticsPage();

  const isResources = selectedType === StatisticsType.Resources;
  const isNapAudit = selectedType === StatisticsType.NapAudit;
  const supportsHallFilter =
    tenantUsesMoreThanOneHall &&
    (selectedType === StatisticsType.Money ||
      selectedType === StatisticsType.Event);

  const children = (
    <>
      <div className={styles.root_fields}>
        <DefaultFormSelectField
          className={styles.root_section_inner_container_duration_dropdown}
          name={nameof<IStatisticsFormModel>((x) => x.type)}
          options={statisticTypeOptions}
          label="Тип на репорта"
          includeId={false}
          tooltip={
            "• Приходи: всички приходи от продажба на абонаменти и посещения<br/><br/>• Посещения: приходи генерирани само и единствено от посещения"
          }
        />

        <RenderWhen condition={isNapAudit}>
          <NapAuditPanel />
        </RenderWhen>

        <RenderWhen condition={!isNapAudit && !isResources}>
          <div data-onboarding="stats-employee-filter">
            <DefaultFormMultiSelectField
              label={"Изберете служители"}
              options={availableEmployees}
              name={nameof<IStatisticsFormModel>((x) => x.userIds)}
              tooltip={
                "Всички активни служители - мениджъри и собственици. Изтритите такива не са включени в списъка. „Всички служители“ включва и активност, създадена от админи извън падащото меню (например посещения на фитнес, сканирани от глобален админ)."
              }
              selectAllOption={
                canSeeAllEmployees
                  ? {
                      id: ALL_USERS_OPTION_ID,
                      name: "Всички служители (вкл. админи)",
                    }
                  : undefined
              }
              includeId={false}
              display="comma"
              showPanelHeader={false}
            />
          </div>
        </RenderWhen>

        <RenderWhen condition={supportsHallFilter}>
          <DefaultFormMultiSelectField
            label={"Изберете зали"}
            options={availableHalls}
            name={nameof<IStatisticsFormModel>((x) => x.hallIds)}
            tooltip={
              "Репортът ще включва само събития, проведени в избраните зали."
            }
            selectAllOption={{
              id: ALL_HALLS_OPTION_ID,
              name: "Всички (вкл. без зададена зала)",
            }}
            includeId={false}
            display="comma"
            showPanelHeader={false}
          />
        </RenderWhen>

        <RenderWhen condition={!isNapAudit}>
          <RangeCalendar
            label="Диапазон"
            maxDate={new Date()}
            minDate={isResources ? RESOURCES_MIN_DATE : undefined}
            dateFromName={nameof<IStatisticsFormModel>((x) => x.dateFrom)}
            dateToName={nameof<IStatisticsFormModel>((x) => x.dateTo)}
          />
        </RenderWhen>
      </div>
      {/* Винаги рендираме бутон-реда (празен за НАП), за да остане балансът на
          space-between в контейнера — иначе полетата се избутват най-долу. */}
      <div className={styles.root_buttons}>
        <RenderWhen condition={!isNapAudit}>
          <DefaultButton label={"Генерирай"} type="submit" />
        </RenderWhen>
      </div>
    </>
  );

  return (
    <FormProvider {...form}>
      <form onSubmit={form.handleSubmit(onSave)}>
        <SingleSectionPageLayout
          title={"Репорти"}
          maxHeight={"80%"}
          children={children}
        />
      </form>
    </FormProvider>
  );
};
